import PermissionsHandler, {
  PermissionModes
} from "./abstract/permissions.handler";
import { FeedbackDto } from "@/server/app.dtos";

export default class FeedbackPermissions extends PermissionsHandler {
  canView(user: FeedbackDto): boolean {
    return this.Check(this.backoffice, "feedbacks", false, PermissionModes.View);
  }

  canEdit(user: FeedbackDto): boolean {
    return this.Check(this.backoffice, "feedbacks", false, PermissionModes.Edit);
  }

  canDelete(user: FeedbackDto): boolean {
    return this.Check(this.backoffice, "feedbacks", false, PermissionModes.Delete);
  }
}
